import React from 'react'

import ProfileInfoRows from './ProfileInfoRows'
import AudienceSegmentsRow from './AudienceSegmentsRow'
import GeoDistributionRow from './GeoDistributionRow'

import DigitalStrengthAndPlatformsRow from './DigitalStrengthAndPlatformsRow'

const RightsHolderProfileFormContent = ({ formik }) => {
  return (
    <>
      <ProfileInfoRows formik={formik} />
      <AudienceSegmentsRow formik={formik} />
      <GeoDistributionRow formik={formik} />
      <DigitalStrengthAndPlatformsRow formik={formik} />
    </>
  )
}

export default RightsHolderProfileFormContent
